import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  SUBSCRIPTIONDETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchSubscriptionDetails = async gid => axiosAuthInstance.get(`${API_END_POINTS.SUBSCRIPTION}/${gid}`);

const fetchPayments = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const queryParam = `&subscriptionGid.EQ=${payload.gid}`;
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  return axiosAuthInstance.get(`${API_END_POINTS.GET_PAYMENTS}${query}${queryParam}${sorting}`);
};

export function* getSubscriptionDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchSubscriptionDetails, action.payload);
    yield put({ type: SUBSCRIPTIONDETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SUBSCRIPTIONDETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* getSubscriptionPayments(action) {
  try {
    const { data: { entity } } = yield call(fetchPayments, action.payload);
    yield put({ type: SUBSCRIPTIONDETAILS.PAYMENTS_SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SUBSCRIPTIONDETAILS.FAILED, payload: e.response.data });
  }
}
